// src/components/ProductGrid.js
import ProductCard from "./ProductCard";

export default function ProductGrid({ items = [], loading = false, error = null, onAdd }) {
  // Loading state
  if (loading) {
    return (
      <ul className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <li
            key={`skeleton-${i}`}
            className="animate-pulse rounded-lg bg-gray-100 aspect-square"
          />
        ))}
      </ul>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="flex items-center justify-center rounded-md border border-[#e4e7ea] bg-white p-10 text-red-600">
        Failed to load products: {error}
      </div>
    );
  }

  // Empty state
  if (!items.length) {
    return (
      <div className="flex items-center justify-center rounded-md border border-[#e4e7ea] bg-white p-10 text-[#6b7280]">
        No products found.
      </div>
    );
  }

  // Deduplicate by (name,color) to avoid multiple rows for each size
  const seen = new Set();
  const deduped = [];
  for (const p of items) {
    const key = `${p.name}__${p.color || ""}`;
    if (!seen.has(key)) {
      seen.add(key);
      deduped.push(p);
    }
  }

  // Success state
  return (
    <ul className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {deduped.map((p) => (
        <li key={`${p.name}-${p.color}`}>
          <ProductCard product={p} onAdd={onAdd} />
        </li>
      ))}
    </ul>
  );
}
